import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { icoCloudOff, icoLoaderLight, IconsModule, icoVerifiedDuo } from '@platform-frontend/ui-tools';
import { PollingStatusComponent } from './polling-status/polling-status.component';

@NgModule({
  declarations: [PollingStatusComponent],
  imports: [CommonModule, IconsModule.withIcons(icoCloudOff, icoLoaderLight, icoVerifiedDuo), TranslocoModule],
  exports: [PollingStatusComponent]
})
export class PollingModule {}
